import classNames from "classnames"
import { Observer } from "mobx-react"
import React, { useEffect, useState } from "react"
import { useIntercom } from "react-use-intercom"

import commonApi from "@/api/common"
import { NormalLink } from "@/component"
import postLayerConfig from "@/config/post-layer"
import { LINK_BOOK_A_DEMO_OP } from "@/consts/link"
import { PopupsEnum } from "@/models/IUserInfo"
import stores from "@/stores"

import styles from "./PostLayer.module.scss"
import { PostTemplate } from "./PostTemplate.d"


export default function PostLayer () {
  const [isLoadIntercom, setIsLoadIntercom] = useState(false)
  const { showNewMessage } = useIntercom()

  useEffect(() => {
    const observer = new MutationObserver(mutations => {

      mutations.forEach(({ addedNodes, previousSibling }) => {
        addedNodes.forEach((node) => {
          if (node.nodeType !== node.ELEMENT_NODE) {
            return
          }

          // @ts-ignore
          if ("intercom-lightweight-app" === (node as Element).className && "intercom-frame" === previousSibling?.id) {
            // 启动了 Intercom
            setIsLoadIntercom(true)
            return
          }

          // 消息会话窗口
          // @ts-ignore
          if ((node as Element).children["intercom-borderless-frame"]) {
            stores.Post.setPostShow(false)
            return
          }
        })
      })
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }, [])

  const newMsgHandle = (e: any) => {
    e.stopPropagation()
    if (PostTemplate.GET_GOOD_REVIEWS === stores.Post.template ||
      PostTemplate.UPGRADE_DOWN_PLAN_POST === stores.Post.template ||
      PostTemplate.EXPERT_HELP === stores.Post.template
    ) return
    if (stores.Post?.handleClickShowMessage) showNewMessage(e)
  }

  const showNewMessageFun = (e: any) => {
    closeHandle(e)
    e.stopPropagation()
    showNewMessage()
  }

  const closeHandle = (e: any) => {
    e.stopPropagation()
    stores.Post.setPostShow(false)
  }

  const closeBookDemoHandle = (e: any) => {
    e.stopPropagation()
    stores.Post.setPostShow(false)
    commonApi.closePopup(PopupsEnum.BOOK_A_DEMO_POPUP)
  }

  return (
    <Observer>{() => {
      const { template } = stores.Post
      const { show } = stores.Post

      return (
        <div>
          <div
            onClick={newMsgHandle}
            className={classNames(styles.PostLayer, show && isLoadIntercom ? styles.Wrapper : styles.Leave)}
          >
            {template !== PostTemplate.EXPERT_HELP && (
              <header className={styles.PostLayerHeader}>
                <div className={styles.Logo}>
                  <img
                    src={postLayerConfig.avatar_url}
                    alt={`${postLayerConfig.nickname} profile`}
                  />
                </div>
                <div className={styles.Title}>
                  <div>
                    <span className={styles.PostLayerNickname}>{postLayerConfig.nickname}&nbsp;</span>
                    from CWILL Tracking
                  </div>
                  <div>
                    <span className={styles.Badge} />
                    Active
                  </div>
                </div>
                <span onClick={closeHandle}  className={styles.Close}>
                </span>
              </header>
            )}

            {template === PostTemplate.EXPERT_HELP && (
              <div className={styles.ExpertHelpHeader}>
                <div className={styles.CloseSVG} onClick={closeBookDemoHandle}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle opacity="0.2" cx="10" cy="10" r="10" fill="black" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M12.9742 13.824C13.2088 14.0586 13.5893 14.0586 13.824 13.824C14.0586 13.5893 14.0586 13.2088 13.824 12.9742L10.8498 9.99999L13.824 7.0258C14.0586 6.79114 14.0586 6.41069 13.824 6.17603C13.5893 5.94137 13.2088 5.94137 12.9742 6.17603L9.99999 9.15021L7.02577 6.17599C6.79112 5.94134 6.41066 5.94134 6.176 6.17599C5.94134 6.41065 5.94134 6.79111 6.176 7.02577L9.15022 9.99999L6.17599 12.9742C5.94134 13.2089 5.94134 13.5893 6.17599 13.824C6.41065 14.0586 6.79111 14.0586 7.02577 13.824L9.99999 10.8498L12.9742 13.824Z" fill="white" />
                  </svg>
                </div>
              </div>
            )}

            {template === PostTemplate.GET_GOOD_REVIEWS && <GetGoodReviewsPost />}
            {template === PostTemplate.GREET && <GreetPost />}
            {template === PostTemplate.ORDER_MESSAGE && <OrderMessagePost />}
            {template === PostTemplate.UPGRADE_DOWN_PLAN_POST && <UpgradeDownPlanPost />}
            {template === PostTemplate.EXPERT_HELP && <ExpertHelpPost />}

            {template !== PostTemplate.EXPERT_HELP && (
              <div className={styles.PostLayerFooter} onClick={showNewMessageFun}>
                <div className={styles.PostLayerInput}>
                  <input type="text" placeholder="Live chat with us" />

                  <div className={styles.PostLayerButtonGroup}>
                    <button className={classNames([styles.PostLayerButtonItem, styles.svgBtn])}>
                      <svg focusable="false" aria-hidden="true" viewBox="0 0 29 18">
                        <g>
                          <path
                            d="M9 1a8 8 0 1 0 0 16h11a8 8 0 1 0 0-16H9zm0-1h11a9 9 0 0 1 0 18H9A9 9 0 0 1 9 0z"
                            fillRule="nonzero"
                          />
                          <path
                            d="M6.561 9.337c0-2.277 1.683-3.795 3.773-3.795 1.298 0 2.2.572 2.849 1.375l-.726.451c-.462-.594-1.243-1.012-2.123-1.012-1.606 0-2.827 1.232-2.827 2.981 0 1.738 1.221 2.992 2.827 2.992.88 0 1.606-.429 1.969-.792v-1.496H9.784v-.814h3.432v2.651a3.822 3.822 0 0 1-2.882 1.265c-2.09 0-3.773-1.529-3.773-3.806zM14.701 13V5.663h.913V13h-.913zm2.629 0V5.663h4.807v.814h-3.894v2.365h3.817v.814h-3.817V13h-.913z"
                          />
                        </g>
                      </svg>
                    </button>

                    <button className={classNames([styles.PostLayerButtonItem, styles.svgBtn])}>
                      <svg focusable="false" aria-hidden="true" viewBox="0 0 18 18">
                        <path
                          d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0zm0 1C4.589 1 1 4.589 1 9s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zM5 6.999a1 1 0 1 1 2.002.004A1 1 0 0 1 5 6.999zm5.999 0a1.002 1.002 0 0 1 2.001 0 1 1 0 1 1-2.001 0zM8.959 13.5c-.086 0-.173-.002-.26-.007-2.44-.132-4.024-2.099-4.09-2.182l-.31-.392.781-.62.312.39c.014.017 1.382 1.703 3.37 1.806 1.306.072 2.61-.554 3.882-1.846l.351-.356.712.702-.35.356c-1.407 1.427-2.886 2.15-4.398 2.15z"
                          fillRule="evenodd"
                        />
                      </svg>
                    </button>

                    <button className={classNames([styles.PostLayerButtonItem, styles.svgBtn])}>
                      <svg focusable="false" aria-hidden="true" viewBox="0 0 16 18">
                        <path
                          d="M14.154 6.918l-.004.003.001-.004-3.287 3.286-.006-.005-3.574 3.574c-.016.017-.03.036-.048.053l-.05.047-.043.041v-.002c-1.167 1.07-2.692 1.331-3.823.2-1.13-1.13-.89-2.677.18-3.843l-.005-.004.074-.073.016-.018c.006-.005.012-.009.017-.016l6.053-6.053.761.76-6.053 6.054-.029.028v.001l-.005.004-.073.074c.011-.01.025-.018.035-.03-.688.75-.93 1.636-.21 2.356.72.72 1.583.456 2.333-.232l-.03.034.04-.042.01-.008.008-.009.033-.03.031-.034.01-.009.007-.009 5.004-5.003.005.006 1.858-1.859c1.223-1.218 1.51-2.913.291-4.132C12.462.806 10.414.74 9.195 1.958L2.248 8.905c.003 0 .006-.002.008-.004-1.625 1.667-1.542 4.43.103 6.074 1.646 1.646 4.474 1.795 6.141.17-.003.002-.004.008-.008.012l.047-.047 6.053-6.054.042-.042.743.78-.025.021.001.002-6.05 6.05-.002.002-.002.001-.046.046h-.002c-2.094 2.04-5.578 1.894-7.652-.18-2.049-2.049-2.15-5.407-.183-7.505l-.006-.005h-.002l.076-.078 6.943-6.944.003-.002.004-.005c1.641-1.64 4.367-1.574 6.008.066 1.64 1.642 1.353 4.014-.288 5.655z"
                          fillRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )
    }
    }</Observer>

  )
}

type IPerson = {
  rate: number
  rates: object
  showModal: boolean
}
const person: IPerson = {
  rate: 0,
  rates: {
    1: "😠",
    2: "😟",
    3: "😐",
    4: "😃",
    5: "🤩",
  },
  showModal: false,
}

// 索要好评
const GetGoodReviewsPost = () => {
  const handleRateClick = (rate: number) => {
    setTimeout(() => stores.Post.setPostShow(false), 3000)

    if (5 === rate) {
      window.open("https://apps.shopify.com/parcelpanel?reveal_new_review=true", "_blank")
      return
    }

    stores.Post.setShowCommentModal(true)
    stores.Post.setRate(rate)
  }

  return (
    <Observer>{() => (
      stores.userInfoSore.data.show_review_guide ? (
        <div>
          <div className={styles.PostLayerTitle}>Thanks for your trust 🎉</div>
          <div className={styles.PostLayerBody}>
            <p>Would you mind letting us know what you think about CWILL Tracking?</p>
            <ul className={styles.PostRate}>
              {
                Object.entries(person.rates)
                  .map(([rate, content]) => (
                    <li key={rate}>
                      <a onClick={() => handleRateClick(parseInt(rate))}>{content}</a>
                    </li>
                  ))
              }
            </ul>
          </div>
        </div>
      ) : null
    )}</Observer>
  )
}

// 打招呼 POST
const GreetPost = () => {
  return (
    <div>
      <div className={styles.PostLayerTitle}>Welcome to CWILL Tracking 🎉</div>
      <div className={styles.PostLayerBody}>
        <p>Hello 😀 ,</p>
        <p>We’re so glad you’re here, let us know if you have any questions.</p>
      </div>
    </div>
  )
}

// 订单页面需要帮助显示的
const OrderMessagePost = () => {
  return (
    <>
      <div className={styles.PostLayerBody}>
        <p>Any questions about orders sync, courier matching or tracking update?</p>
      </div>
    </>
  )
}

// 付费套餐升降级显示的
const UpgradeDownPlanPost = () => {
  return (
    <div>
      <div className={styles.PostLayerTitle}>Thanks for your trust 🎉</div>
      <div className={styles.PostLayerBody}>
        <p>The system won{"'"}t deduct that much for the sum of your new and old plans.</p>
        <p>
          The charge is prorated based on Shopify official billing API.
          {" "}
          <NormalLink
            link="https://help.shopify.com/en/manual/your-account/manage-billing/your-invoice/apps#app-prorating-upgrades-and-downgrades"
            external
          >
            Learn more.
          </NormalLink>
        </p>
      </div>
    </div>
  )
}

// 专家帮助弹窗
const ExpertHelpPost = () => {
  const { showNewMessage } = useIntercom()

  const handleChatClick = (e: any) => {
    e.stopPropagation()
    stores.Post.setPostShow(false)
    showNewMessage()
  }

  const handleDemoClick = (e: any) => {
    e.stopPropagation()
    // 这里可以添加预约演示的逻辑
    // 例如打开新窗口或显示预约表单
    window.open(LINK_BOOK_A_DEMO_OP, "_blank")
    stores.Post.setPostShow(false)
  }

  return (
    <div className={styles.ExpertHelpPost}>
      <div className={styles.ExpertAvatars}>
        <img
          src={"https://cdn.parcelpanel.com/front-end/2025/common/admin/intercom-popup-cs-avatars.png"}
          alt={""}
          className={styles.ExpertAvatar}
          title={""}
        />
      </div>

      <div className={styles.ExpertTitle}>
        <span className={styles.WaveEmoji}>👋</span> Hi! Need any help from our expert?
      </div>

      <div className={styles.ExpertActions}>
        <button
          onClick={handleChatClick}
          className={styles.ChatButton}
        >
          Chat with us
        </button>
        <button
          onClick={handleDemoClick}
          className={styles.DemoButton}
        >
          Get a 1:1 demo
        </button>
      </div>
    </div>
  )
}
